import { IFullPairingPosition, IPosition, IUser, OpenFlyingStatusType } from "@vmosolutions/oc-interfaces";

/**
 * Returns a new positions array with `crewMember` assigned to the slot at `index`, first clearing
 * them out of any other slot they already hold on the pairing so nobody is double-booked.
 *
 * Shared by the pairing editor's crew drop target and its "Available Crew" dropdown, so a crew
 * member lands in a slot the same way whether they were dragged in or picked from the list.
 */
export const assignCrewToPositions = (
  positions: IFullPairingPosition[],
  index: number,
  position: IPosition,
  crewMember: IUser
): IFullPairingPosition[] => {
  const updated: IFullPairingPosition[] = [...positions];
  const dupIndex = updated.findIndex((existing: IFullPairingPosition) => existing.crew?._id === crewMember._id);
  if (dupIndex >= 0) {
    updated[dupIndex] = { ...updated[dupIndex], crew: null };
  }
  updated[index] = {
    crew: crewMember,
    position,
    openFlyingStatus: OpenFlyingStatusType.Closed, // Reset to closed when position re-assigned
  };
  return updated;
};
